module.exports = __webpack_public_path__ + "img/card-offer-pitaya.26a07b05.png";